import React, { useEffect } from "react";
import { IoClose } from "react-icons/io5";

const Alert = ({ message, type = "error", isVisible, onClose }) => {
  useEffect(() => {
    if (isVisible) {
      // 3 saniye sonra otomatik kapanma
      const timer = setTimeout(() => {
        onClose();
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [isVisible, onClose]);

  if (!isVisible) return null;

  const alertStyles = {
    error: "bg-red-50 text-red-800 border-red-200",
    success: "bg-green-50 text-green-800 border-green-200",
    warning: "bg-yellow-50 text-yellow-800 border-yellow-200",
    info: "bg-blue-50 text-blue-800 border-blue-200",
  };

  return (
    <div className="fixed top-4 right-4 z-50 animate-slide-in">
      <div
        className={`rounded-lg p-4 border ${alertStyles[type]} shadow-lg max-w-md`}
      >
        <div className="flex items-start">
          <div className="flex-1">{message}</div>
          <button
            onClick={onClose}
            className="ml-4 inline-flex text-gray-400 hover:text-gray-500 focus:outline-none"
          >
            <IoClose className="h-5 w-5" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default Alert;
